/* eslint-disable no-restricted-syntax */

import { useEffect, useState } from 'react';
import { globalConfig } from '../config/config';
import BaseUrls from '../utils/baseUrls';
import WorkspaceStyle from '../css/workspaceStyle';
import SuccessBody from '../components/success/successBody';

const Success = () => {
  const [theme, setTheme] = useState('');

  function onLoad() {
    if (globalConfig.config) {
      const Customtheme = BaseUrls.getkey();
      setTheme(Customtheme);
    }
  }

  useEffect((
  ) => { onLoad(); }, []);
  const setWorkspaceStyle = () => {
    let workStyle = '';
    switch (theme) {
      case 'zeeve':
        workStyle = WorkspaceStyle.zeeveStyle();
        break;
      case 'helious':
        workStyle = WorkspaceStyle.heliosStyle();
        break;
      case 'phaeton':
        workStyle = WorkspaceStyle.heliosStyle();
        break;
      default:
        workStyle = WorkspaceStyle.zeeveStyle();
        break;
    }
    return workStyle;
  };

  return (
        <>
            <style>{setWorkspaceStyle()}</style>

                    <SuccessBody />
        </>
  );
};

export default Success;
